export default "__VITE_ASSET__0a6bd46b__"